import utils from './utils';

let viewRouteDetails = function(agencyName, routeShortName) {
  location.href = '/maps-schedules/' + utils.slugify(agencyName) + '/' + utils.slugify(routeShortName);
}
let modeIcons = [
  { otpKey: 'CAR', googleKey: 'DRIVING', class: 'icon-icon-park-and-ride', type: 'non-transit' },
  { otpKey: 'BICYCLE', googleKey: 'BICYCLING', class: 'icon-icon-bike', type: 'non-transit' },
  { otpKey: 'WALK', googleKey: 'WALKING', class: 'icon-icon-walk', type: 'non-transit' },
  { otpKey: 'BUS', googleKey: 'BUS', class: 'icon-icon-bus', type: 'transit' },
  { otpKey: 'RAIL', googleKey: 'RAIL', class: 'icon-icon-light-rail', type: 'transit' },
  { otpKey: 'SUBWAY', googleKey: 'SUBWAY', class: 'icon-icon-light-rail', type: 'transit' },
  { otpKey: 'TRAM', googleKey: 'TRAM', class: 'icon-icon-light-rail', type: 'transit' },
  { otpKey: 'TRAIN', googleKey: 'TRAIN', class: 'icon-icon-light-rail', type: 'transit' },
]
export {
  viewRouteDetails, modeIcons
}
export default {
  viewRouteDetails, modeIcons
}



// WEBPACK FOOTER //
// ./src/helpers/common.js